// base js file
require("./base/navbar");
require("./base/drawer");
require("./base/dropdown");
require("./base/settings");
require("./base/accordion");
require("./base/product-view");
require("./base/preloader");
require("./base/tab");

// checkbox checked style
document.querySelectorAll(".checkbox-checked").forEach(element => {
    if (element.checked) {
        element.style = "background-image: url('assets/img/icons/check/color-checked-squire.svg')";
    } else {
        element.style = "";
    }
    element.addEventListener('change', () => {
        if (element.checked) {
            element.style = "background-image: url('assets/img/icons/check/color-checked-squire.svg')";
        } else {
            element.style = "";
        }
    })
})
